import React, { Component } from "react";
import PageHeaderWrapper from "../../../../components/PageHeaderWrapper";
import TableComp from "../../../../components/_utils/table";
import moment from "moment";
import {
  Card,
  DatePicker,
  Select,
  Tooltip,
} from "antd";
import Request from "../../../../request";
import Settings from "../../../../components/_utils/settings";
import lodash from "lodash";
import { connect } from "react-redux";
import styles from "./styles.less";
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let localUser = JSON.parse(localStorage.getItem('user'));
let desks = {
  'Front Desk': '/desk/update-counselling',
  'Registration Desk': '/registration/fees',
  'Application Desk': '/desk/allApplication-desk/update',
  'Visa Desk': '/desk/getVisa',
  'Claim Desk': '/desk/getClaim',
  'Operation Manager Desk': '/operation-manager-inquiry/update'
};
class AllStudentSearch extends Component {
  state = {
    count: 0,
  };

  constructor(props) {
    super(props);
    this.table = React.createRef();
  }

  apiRequest = (params, columns) => {
    return new Promise(async (resolve) => {
      if (!params.sortField) {
        params.sortField = "updatedByUser.time";
        params.sortOrder = "descend";
      }

      let searchParams = new URLSearchParams(this.props.search);
      let studentSearch = searchParams.get("keyword");

      if (studentSearch) {
        params.keyword = studentSearch;
      }

      let data = await Request.getAllSearchStudent({
        ...params
      });

      delete data.error;
      delete data.type;

      this.setState({
        count: data.total
      });
      resolve(data);
    });
  };

  componentWillMount() {

  }

  async componentDidMount() {

  }

  returnDeskName = (record) => {
    const deskConfig = Settings.allDesks;

    let findIn = lodash.find(deskConfig, (rr) => {
      return rr.name == record.atLevel;
    });

    if (findIn) {
      return (
        <div
          style={{
            backgroundColor: findIn.color,
            color: "white",
            padding: 3,
            display: "inline-block",
            fontWeight: "bold",
          }}
        >
          {
            localUser.isFinanceAdmin || localUser.isFinanceAdmin ?
              <a
                style={{ color: 'white' }}
                size={"small"}
                href={(record.atLevel && desks[record.atLevel] ? desks[record.atLevel] : 'documents') + "?id=" + record._id}
              >{Settings.deskNameObj[record.atLevel]}</a>
              :
              Settings.deskNameObj[record.atLevel]
          }
        </div>
      );
    } else {
      return <div>{record.atLevel}</div>;
    }
  };

  render() {

    let columns = [
      {
        title: "Vision ID",
        key: "id",
        width: 100,
        dataIndex: "id",
        sorter: true,
        searchTextName: "id",
        filterRegex: true,
      },
      {
        title: "Student Name",
        key: "studentName",
        width: 110,
        render: (item, record) => {
          let url = desks[record.atLevel];
          let finalUrl = `${url}?id=${record._id}`;
          return (
            <React.Fragment>
              <div
              >
                <Tooltip>
                  <a
                    className={styles.btn}
                    target={"_blank"}
                    href={finalUrl}
                  >
                    {item}
                  </a>
                </Tooltip>
              </div>
            </React.Fragment>
          );
        },
      },
      {
        title: "DOB",
        sorter: true,
        key: "dateOfBirth",
        width: 110,
        render: (val, record) => {
          return (
            <div>
              {record.dateOfBirth
                ? moment(record.dateOfBirth).format(dateFormat)
                : ""}
            </div>
          );
        },
      },
      {
        title: "Passport Number",
        width: 100,
        key: "profile.passportNumber",
        render: (val, record) => {
          return (
            <div>
              {val}
            </div>
          );
        },
      },
      {
        title: 'Institute Student Id',
        key: 'visaDesk.selectedCourse.instituteStudentId',
        render: (item) => {
          return item;
        },
        width: 120
      },
      {
        title: 'Course/University',
        key: 'visaDesk.selectedCourse',
        width: 250,
        render: (text, record) => {
          return (<div>
            <div>{text ? text.courseName : ''}{text ? text.campusName ? `(${text.campusName})` : '' : ''}</div>
            <div>{text ? text.universityInstitutionName : ''}</div>
          </div>)
        }
      },
      {
        title: 'Start Date',
        key: 'visaDesk.courseStartDate',
        width: 100,
        render: (text, record) => {
          return (
            <div>{text ? moment(text).format(dateFormat) : ''}
            </div>
          )
        }
      },
      {
        title: 'Arrival Date',
        key: 'visaDesk.arrivalDate',
        width: 100,
        render: (text, record) => {
          return (
            <div>{text ? moment(text).format(dateFormat) : ''}
            </div>
          )
        }
      },
      {
        title: "Branch",
        width: 80,
        key: "studentBranchId",
        render: (text, record) => {
          return (
            <div>
              {record.studentBranchId ? record.studentBranchId.branchName : ""}
            </div>
          );
        },
      },
      {
        title: "At Stage",
        key: "atLevel",
        dataIndex: "atLevel",
        width: 150,
        render: (val, record) => {
          return this.returnDeskName(record);
        },
      },
      {
        title: 'Transfered Dates',
        key: 'moveDeskDate',
        dataIndex: 'moveDeskDate',
        width: 200,
        render: (text, record) => {
          return (
            <div>
              <div><b>Visa Desk:- </b> {text && text.moveToVisaDesk ? moment(text.moveToVisaDesk).format(dateFormat) : ''}</div>
              <div><b>Claim Desk:- </b> {text && text.moveToClaimDesk ? moment(text.moveToClaimDesk).format(dateFormat) : ''}</div>
              <div><b>Archive Desk:- </b> {text && text.moveToArchiveDesk ? moment(text.moveToArchiveDesk).format(dateFormat) : ''}</div>
            </div>
          )
        }
      },
    ];

    return (
      <PageHeaderWrapper
        title={` STUDENTS SEARCH : ${this.state.count} `}
      >
        <Card bordered={true}>
          <TableComp
            id={"AllStudentSearch"}
            showSelector={true}
            columns={columns}
            ref={this.table}
            apiRequest={(params) => this.apiRequest(params, columns)}
            extraProps={{ scroll: { x: 1000 } }}
            pagination={{
              showSizeChanger: true,
              defaultPageSize: 100,
              pageSizeOptions: ["10", "20", "50", "100", "1000"],
            }}
          />
        </Card>
      </PageHeaderWrapper>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  categories: global.categories,
  search: router.location.search,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllStudentSearch);
